import axios from "axios";

const httpClient = axios.create({ baseURL: "BASE_URL" });

export default httpClient;